// extracted by mini-css-extract-plugin
module.exports = {"image":"TopicHeader-module--image--1rGEl","icon":"TopicHeader-module--icon--uM_X9","title":"TopicHeader-module--title--2MY4O"};